module.exports = __webpack_public_path__ + "img/top_bg.4ec7565e.png";